<script> 
	import { 
		headerTitleHome, 
		linkAV, 
		linkPesquisaVendas,
		linkPesquisaLocacao,
		linkPesquisaTemporada,
		linkInstagram,
		linkConheca
	} from '../store.js';
	
	import { link }         		from "svelte-routing";
	import { onMount, onDestroy  }	from 'svelte';
	import Vitrine          		from '../components/Vitrine.svelte'
	import ListaImoveis    			from '../components/ListaImoveis.svelte'
	import Busca					from '../components/Busca.svelte'
	import Instagram				from '../components/Instagram.svelte'

	let vitrines = [
		{
			image: 'vitrineCod4577.jpg', 
			imageMobile: 'vitrineCod4577M.jpg', 
			title: 'Imóvel',
			href: '/imovel/Venda/4577/imovel-Apto-em-Centro-TRAMANDAI-Cod-4577'
		},
		{
			image: 'vitrineCod4690.jpg', 
			imageMobile: 'vitrineCod4690M.jpg', 
			title: 'Imóvel',
			href: '/imovel/Venda/4690/imovel-Apto-em-beira-mar-TRAMANDAI-Cod-4690'
		},
		{
			image: 'vitrineCod4106.jpg', 
			imageMobile: 'vitrineCod4106M.jpg', 
			title: 'Imóvel',
			href: '/imovel/Venda/4106/imovel-Apto-em-Centro-TRAMANDAI-Cod-4106'
		},
		{
			image: 'vitrineCredpago.jpg', 
			imageMobile: 'vitrineCredpagoM.jpg', 
			title: 'Credpago',
			href: '/garantias-locaticias'
		},
		{
			image: 'vitrineApp.jpg', 
			imageMobile: 'vitrineAppM.jpg', 
			title: 'Aplicativo',
			href: $linkConheca,
			target: '_blank'
		},
	];
	
	/* Imóveis */ 
	function search(e) {
		let url = '/imoveis/';
		if (e.detail.tipo_negociacao == atria.rent) {
			url += 'locacao';
		} else if (e.detail.tipo_negociacao == atria.sell) {
			url += 'vendas';
		} else {
			url += 'temporada';
		}
		url += '#' + Object.entries(e.detail).filter(p=>p[1].toString().length>0&&p[1].toString()!='0').flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');

		document.location = url;
	}
	
	let filtrosDestaquesLocacao = {nt:atria.rent, tipo_negociacao:atria.rent, pageSize:6, random: 1, destaque:true, force: true};
	let filtrosDestaquesTemporada = {nt:atria.rentExtra, tipo_negociacao:atria.rentExtra, pageSize:6, random: 1, force: true};
	let filtrosDestaquesVendas = {nt:atria.sell, tipo_negociacao:atria.sell, pageSize:6, random: 1, destaque:true, force: true};

	function activateSlickLocacao(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--locacao').style.display = 'none';
		} else {
			activateSlick('.destaques-home--locacao');
		}
	}
	function activateSlickTemporada(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--temporada').style.display = 'none';
		} else {
			activateSlick('.destaques-home--temporada');
		}
	}
	function activateSlickVendas(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--vendas').style.display = 'none';
		} else {
			activateSlick('.destaques-home--vendas');
		}
	}
	function activateSlick(selector) {
		window.setTimeout(()=>{            
			jQuery(selector).show();
			jQuery(selector + ' .row').slick({
				infinite: true,
				speed: 400,
				slidesToShow: 3,
				slidesToScroll: 3,
				autoplay: true,
				arrows: false,
				dots: true,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
						}
					},
					{
						breakpoint: 850,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
						}
					}
				]
			});
		}, 500);
	}
	function toggleMenu() {
		document.querySelector('header').classList.toggle('hidden');
	}

	let selectedNegotiationType = -2;
	function changeNegotiationType(nt) {
		selectedNegotiationType = nt;
	}
	//Esconde cabecalho
	onMount(async () => {
		document.querySelector('body').classList.add('site--home');
		document.querySelector('header').classList.add('hidden');
	});
	onDestroy(async () => {
		document.querySelector('body').classList.remove('site--home');
		document.querySelector('header').classList.remove('hidden');
	});
</script>

<svelte:head>
	<title>{$headerTitleHome}</title>
</svelte:head>


<Vitrine vitrines={vitrines} showDots={true} vitrineHeight="500px"/>

<section class="busca">
	<div class="container">
		<Busca on:filter={search} /> 
	</div>
</section>

<!-- Destaques Comprar -->
<section class="section destaques-home destaques-home--vendas">
	<div class="container">
		<div class="header">
			<h2 class="title">
				<a class="color-accent" href="{$linkPesquisaVendas}">Compra e Venda</a> de imóveis e empreendimentos
			</h2>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesVendas} showPaginator={false} afterLoadRealties={activateSlickVendas} />
	</div>
</section>

<!--Aplicativo-->
<section class="section section-aplicativo mt-10">
	<div class="container">
		<img  src="/assets/images/sobre.jpg" alt="Sede da imobiliária">
		<div class="box">
			<h3><span class="color-accent">Administração de condomínios</span><br/>com agilidade e competência</h3>
			<p class="no-breakline--xs color-primary mt-10 mb-10">Conte com nossa equipe especializada e<br/> modernas ferramentas para garantir uma<br/>gestão tranquila do seu condomínio.</p>
			<div class="buttons pt-20">
				<a href="/administracao-condominios" class="btn btn-primary">Confira os benefícios</a>
				<a href="/solicite-proposta" class="btn btn-secondary">Solicite uma proposta</a>
			</div>
		</div>
	</div>
</section>

<!-- Destaques Locação -->
<section class="section destaques-home destaques-home--locacao">
	<div class="container">
		<div class="header">
			<h2 class="title">
				<a class="color-accent" href="{$linkPesquisaLocacao}">Aluguel</a> residencial e comercial 
			</h2>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesLocacao} showPaginator={false} afterLoadRealties={activateSlickLocacao} />
	</div>
</section>

<!-- Destaques Temporada -->
<section class="hide section destaques-home destaques-home--temporada">
	<div class="container">
		<div class="header">
			<h2 class="title">
				Aluguel <a class="color-accent" href="{$linkPesquisaTemporada}">por temporada</a> 
			</h2>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesTemporada} showPaginator={false} afterLoadRealties={activateSlickTemporada} />
	</div>
</section>

<section class="section section-ajuda">
	<div class="container">
		<div class="header">
			<h2 class="title text-center">
				<span class="color-accent">Queremos ajudar</span>, o que você procura?
			</h2>
		</div>
		<div class="itens">
			<a href="/anuncie" use:link replace>
				<i class="far fa-megaphone"></i>
				<h3 class="subtitle">Anunciar meu imóvel</h3>
			</a>
			<a href="/solicite" use:link replace>
				<i class="far fa-home-heart"></i>
				<h3 class="subtitle">Solicitar um imóvel</h3>
			</a>
			<a href="/documentacao-necessaria" target="_blank">
				<i class="far fa-file-signature"></i>
				<h3 class="subtitle">Como faço para alugar?</h3>
			</a>
			<a href="{$linkAV}" use:link replace>
				<i class="far fa-barcode-alt"></i>
				<h3 class="subtitle">Boletos e financeiro</h3>
			</a>
		</div>
	</div>
</section>

<section class="section section-social">
	<div class="container">
		<div class="header">
			<h2 class="title text-center">
				<a href="{$linkInstagram}" target="_blank" class="color-accent">@imobiliariacallegaro</a> nas redes sociais
			</h2>
		</div>
	</div>
	<Instagram />
</section>